import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Page::Settings::Roles::Details @role={{this.model}} />")